export const normalizeDni = (value = "") => {
    let cleanValue = String(value).replace(/\D/g, "");
    if (cleanValue.length > 8) {
        cleanValue = cleanValue.slice(0, 8);
    }
    return cleanValue;
};

export const flattenInstituciones = (data = {}) => {
    const flat = [];

    Object.entries(data).forEach(([region, lista]) => {
        if (!Array.isArray(lista)) return;

        lista.forEach((item) => {
            flat.push({
                region,
                institucion_id: item?.institucion_id ?? "",
                nombre_ie: item?.nombre_ie ?? "",
                rol_nombre: item?.rol_nombre ?? "",
                ubicacion_id: item?.ubicacion_id ?? "",
            });
        });
    });

    return flat;
};

export const getRegionCodesFromInstituciones = (instituciones = []) => {
    return Array.from(
        new Set(
            instituciones
                .map((item) => String(item?.ubicacion_id ?? "").slice(0, 2))
                .filter(Boolean)
        )
    );
};

export const getRegionesAsignadas = (
    instituciones = [],
    listaRegiones = []
) => {
    const codigosRegion = getRegionCodesFromInstituciones(instituciones);

    return listaRegiones.filter((region) =>
        codigosRegion.includes(String(region?.id ?? ""))
    );
};

export const getRegionNombreById = (regiones = [], regionId = "") => {
    if (!regionId) return "";

    const regionEncontrada = regiones.find(
        (region) => String(region?.id) === String(regionId)
    );

    return regionEncontrada?.nombre ?? "";
};

export const getIIEEFiltradasByProyecto = (
    proyectoId = "",
    regionesFiltradas = [],
    iieeOptions = []
) => {
    if (!proyectoId) return [];

    const regionNombre = getRegionNombreById(regionesFiltradas, proyectoId);
    if (!regionNombre) return [];

    return iieeOptions.filter(
        (item) => String(item?.region ?? "") === String(regionNombre)
    );
};

export const getAutoSelectedProyecto = (regionesFiltradas = []) => {
    return regionesFiltradas.length === 1 ? regionesFiltradas[0]?.id ?? "" : "";
};

export const getAutoSelectedIIEE = (iieeFiltradas = []) => {
    return iieeFiltradas.length === 1
        ? iieeFiltradas[0]?.institucion_id ?? ""
        : "";
};

export const shouldShowProyectoSelect = (regionesFiltradas = []) => {
    return regionesFiltradas.length > 1;
};

export const shouldShowIIEESelect = (
    regionesFiltradas = [],
    iieeOptions = []
) => {
    return !(
        regionesFiltradas.length === 1 &&
        iieeOptions.length === 1
    );
};

export const getLoginInitialState = () => ({
    dni: "",
    regiones: [],
    regionesFiltradas: [],
    proy: "",
    iieeOptions: [],
    iieeFiltradas: [],
    iiee: "",
});

export const resetLoginState = ({
    setIIEEOptions,
    setIIEE,
    setRegionesFiltradas,
    setProy,
    setIIEEFiltradas,
}) => {
    if (typeof setIIEEOptions === "function") setIIEEOptions([]);
    if (typeof setIIEE === "function") setIIEE("");
    if (typeof setRegionesFiltradas === "function") setRegionesFiltradas([]);
    if (typeof setProy === "function") setProy("");
    if (typeof setIIEEFiltradas === "function") setIIEEFiltradas([]);
};